<template>
  <article class="general_reports">

    <div class="table_card">
      <div class="table_card__head">
        <p class="table_card__head--title">
          Reporte general de reservas
        </p>
      </div>
      <div class="table_card__body">
        <section class="general_reports__section">
          <p class="table_card__info--label">Selecciona el filtro que desees</p>
          <v-flex xs12 sm6 d-flex>
            <v-select
              v-model="time_selected"
              :items="time_filters"
              label="Filtro de tiempo"
              solo
            >
            </v-select>
          </v-flex>
          <date-picker
            v-model="date_selected"
            valueType="format"
            type="date"
            placeholder="Seleccione la fecha"
            v-if="time_selected == 'Diario'"
            solo
          ></date-picker>

          <date-picker
            v-model="date_selected"
            valueType="format"
            type="month"
            placeholder="Seleccione el mes"
            v-else-if="time_selected == 'Mensual'"></date-picker>
          <date-picker
            v-model="date_selected"
            valueType="format"
            type="year"
            placeholder="Seleccione el año"
            v-else-if="time_selected == 'Anual'"></date-picker>
          <date-picker
            v-model="date_selected"
            valueType="format"
            range
            placeholder="Seleccione el rango de fechas"
            v-else-if="time_selected == 'Semanal'"></date-picker>
          <date-picker
            v-model="date_selected"
            valueType="format"
            range
            placeholder="Seleccione el rango de fechas (semestre)"
            v-else-if="time_selected == 'Semestral'"></date-picker>
          <!-- <app-date-picker-export
            @sendDates="exportExcel(false ,$event)">
          </app-date-picker-export> -->
        </section>
        <section class="general_reports__section">
          <p class="table_card__info--label">Selecciona las sedes que desees</p>
          <div class="general_reports__checkbox_container">
            <v-checkbox
              v-for="(location, index) in available_locations"
              :key="index"
              v-model="location_selected"
              :label="location.name"
              :value="location.location_id"
              color="#1476FB"
              class="general_reports__checkbox_container--checkbox"
            >
            </v-checkbox>
            <div class="general_reports__checkbox_container--checkbox"></div>
          </div>
        </section>
      </div>
      <div class="table_card__footer">
        <button
          class="faccess_button"
          @click="createReport()">Generar reporte
        </button>
      </div>
    </div>
  </article>

</template>

<script>
export default {
  data() {
    return{
      datesToSearch:[],
      responses: [],
      total_entrenamiento:'',
      location_query: '',
      only_gyms: [],
      graficaPrueba:[],
      all_queriesSimultaneamnete: '',
      training: true,
      aforo_total: true,
      aforo_total_ocupacion:true,
      simultaneamente: true,
      chartOptions: {

          training:{},
          aforo_total: {},
          simultaneamente:{},
          aforo_total_ocupacion:{},

        },
        series: {

          training: [0],
          aforo_total: [],
          aforo_total_ocupacion:[],
          simultaneamente: [],

        },
      available_locations: [],
      location_selected:[],
      time_selected:null,
      time_selected_simultaneamente:null,
      time_selected_total:null,
      time_selected_aforo:null,
      time_selected_trainig:null,
      time_filters:['Diario', "Semanal", "Mensual"],
      time_filters_simultaneamente:['Diario', "Semanal", "Mensual"],
      time_filters_total:["Semanal", "Mensual"],
      months_text:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],
      day_today: '',
      date_selected:'',
    }
  },
  watch:{
    date_selected(){
      console.log(this.date_selected);
    },

  },
      created(){
      this.active_tab='0';
    },
  methods:{
    getLocations(){
     let params = { page: this.page }
      const data={company:{id:this.getCompany().id}}
      try {
        this.$http.post('locations/company',{data:this.encrypt(data).toString()},{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
           params
        }).then(function(response){
            this.sortAvailableLocations(response.body)
          })
      } catch (e) {
        alert(e)
      }
    },
    sortAvailableLocations(dataResponse){
      this.available_locations=[]
      this.location_selected=[]
      for( var i = 0;i< dataResponse.data.length ; i++ ){
        if(dataResponse.data[i].attributes.published == true){
          this.available_locations.push({
            location_id: parseInt(dataResponse.data[i].id),name:dataResponse.data[i].attributes.name
          })
          this.location_selected.push(parseInt(dataResponse.data[i].id))
        }
      }
      console.log('verificando ',this.available_locations,this.location_selected)
    },

    divideDate(){
      if (this.datesToSearch.length > 0){
        console.log('Limpiando Dates')
        this.datesToSearch= []
      }

      let dateZero = this.date_selected[0]
      let dateOne = this.date_selected[1]
      let yearZero = this.date_selected[0].substring(0,4)
      let yearOne = this.date_selected[1].substring(0,4)
      let monthZero = this.date_selected[0].substring(5,7)
      let monthOne = this.date_selected[1].substring(5,7)
      let dayZero = this.date_selected[0].substring(8,10)
      let dayOne = this.date_selected[1].substring(8,10)
      this.diffYear = Math.abs(yearZero - yearOne)
      let totalDayPerMonthZero = new Date(parseInt(yearZero),parseInt(monthZero)+1,0)
      let totalDayPerMonthOne = new Date(parseInt(yearOne),parseInt(monthOne)+1,0)
      let firstDaysMonth = `${yearZero}-${monthZero}-${totalDayPerMonthOne.getDate()}`
      let lastDaysMonth = `${yearOne}-${monthOne}-01`

      //parametro fecha inicial
      let optainFirstDate = [ dateZero , firstDaysMonth]

      this.datesToSearch.push(optainFirstDate)

      if( this.diffYear == 1 ){
        //parametros meses año 1
        for(var i = 1; i < (12-monthZero)+1 ; i++){
          this.datesToSearch.push(`${yearZero}-${parseInt(monthZero)+i}`)
        }
        //parametros meses año 2
        for(var i = 0; i < monthOne-1 ; i++){
          this.datesToSearch.push(`${yearOne}-${i+1}`)
        }
      }else if( this.diffYear == 0){
        for(var i = 1; i < parseInt(monthOne)-parseInt(monthZero) ; i++){
          this.datesToSearch.push(`${yearZero}-${parseInt(monthZero)+i}`)
        }
      }
      //parametro final
      if (parseInt(dayOne) == 1){
        this.datesToSearch.push(`${yearOne}-${parseInt(monthOne)}`)
      }else{
        let optainLastDate = [ lastDaysMonth , dateOne ]
        this.datesToSearch.push(optainLastDate)
      }

      console.log('todas las fechas a buscar',this.datesToSearch)

    },
    createReport(){
      if (this.responses.length > 0){
        console.log('Limpiando response')
        this.responses= []
      }      
      this.getDataReport(this.date_selected, this.time_selected, this.location_selected , true)      
    },
    getDataReport(date,filter,locations,throwExcel){
      this.$http.get('app/locations/personalize_general_report',
        {
          headers: {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken(),
          },
          params:{
            // location_id: 6,
            date_selected: date,
            filter_type: filter,
            locations: locations
          },
          responseType: 'ArrayBuffer'
        }).then(function(response){
          console.log('la respuesta',response.body);
          let shortResponse = response.body.data.attributes
          let responseConcat = shortResponse.active.concat(shortResponse.cancelled.concat(shortResponse.completed.concat(shortResponse.unused.concat(shortResponse.used.concat(shortResponse.active_invitations.concat(shortResponse.completed_invitations.concat(shortResponse.cancelled_invitations.concat(shortResponse.unused_invitations))))))))
          responseConcat.forEach( element =>{
            this.responses.push(element)
          })
          if (throwExcel==true){
            this.makeExcelReport(this.responses)
          }
          if(response.body.meta != undefined &&
              response.body.meta != null){
            if(response.body.meta.authentication_token != undefined &&
                response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)

            }
            return this.responses
          }}, function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          })
      },
    makeExcelReport(responseConcat){
      responseConcat.forEach(element=> {
        delete element.sublocation_id
        element['is_invitation1']=element['is_invitation']
        element['state1']=element['state']
        element['weekday1']=element['weekday']
        element['data_start_time1'] = element.start_time.substring(0,10)
        element['hour_start_time1'] = element.start_time.substring(11,16)
        element['data_end_time1'] = element.end_time.substring(0,10)
        element['hour_end_time1'] = element.end_time.substring(11,16)
        element['local_time1'] = element['local_time']
        element['time_of_entry1'] = this.dateFormatText(element['time_of_entry'], element.time_zone)
        element['departure_time1'] = this.dateFormatText(element['departure_time'], element.time_zone)
        element['gym1'] = element['gym']
        element['training_room1'] = element['training_room']
        element['email1'] = element['email']
        element['mobile1'] = element['mobile']
        element['rut1'] = element['rut']
        element['name1'] = element['name']
        element['last_name1'] = element['last_name']
        element['membership_type1'] = element['membership_type']
        element['plan_type1'] = element['plan_type']
        element['duration1'] = element['duration']
        delete element.end_time
        delete element.start_time
        delete  element.time_zone
        delete element['is_invitation']
        delete element['state']
        delete element['weekday']
        delete element['local_time']
        delete element['time_of_entry']
        delete element['departure_time']
        delete element['gym']
        delete element['training_room']
        delete element['email']
        delete element['mobile']
        delete element['rut']
        delete element['name']
        delete element['last_name']
        delete element['membership_type']
        delete element['plan_type']
        delete element['duration']
        element['is_invitation']=element['is_invitation1']
        element['state']=element['state1']
        element['weekday']=element['weekday1']
        element['data_start_time'] = element['data_start_time1']
        element['hour_start_time'] = element['hour_start_time1']
        element['data_end_time'] = element['data_end_time1']
        element['hour_end_time'] = element['hour_end_time1']
        element['local_time'] = element['local_time1']
        element['time_of_entry'] = element['time_of_entry1']
        element['departure_time'] = element['departure_time1']
        element['gym'] = element['gym1']
        element['training_room'] = element['training_room1']
        element['email'] = element['email1']
        element['mobile'] = element['mobile1']
        element['rut'] = element['rut1']
        element['name'] = element['name1']
        element['last_name'] = element['last_name1']
        element['membership_type'] = element['membership_type1']
        element['plan_type'] = element['plan_type1']
        element['duration'] = element['duration1']
        delete element['is_invitation1']
        delete element['state1']
        delete element['weekday1']
        delete element['data_start_time1']
        delete element['hour_start_time1']
        delete element['data_end_time1']
        delete element['hour_end_time1']
        delete element['local_time1']
        delete element['time_of_entry1']
        delete element['departure_time1']
        delete element['gym1']
        delete element['training_room1']
        delete element['email1']
        delete element['mobile1']
        delete element['rut1']
        delete element['name1']
        delete element['last_name1']
        delete element['membership_type1']
        delete element['plan_type1']
        delete element['duration1']
      });
      console.log("probando excel 1", responseConcat)
      let data = XLSX.utils.json_to_sheet(responseConcat);

      const workbook = XLSX.utils.book_new();

      let filename = "Reporte general personalizado"

      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
    exportExcel(reload = false, dates){
      // Fechas seleccionadas
      var object = dates != undefined && dates != null ? dates : {date_from: '', date_to: ''}
      var first_date_element = object.date_from
      var last_date_element = object.date_to
      var firstDate = null;
      var secondDate = null;
      if(first_date_element!=null && last_date_element!=null && !reload){
        if(first_date_element !="" || last_date_element !=""){
          secondDate = new Date(last_date_element);
          firstDate = new Date(first_date_element);
          secondDate.setHours(23,59,59);
          secondDate.setDate(secondDate.getDate());
          firstDate.setHours(0,0,0,0);
          firstDate.setDate(firstDate.getDate());

          firstDate = this.$moment(firstDate).format("YYYY-MM-DD")
          secondDate = this.$moment(secondDate).format("YYYY-MM-DD")
        }
      }

      this.$http.get('app/locations/export_bookings_report',
        {
          headers: {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken(),
          },
          params:{
            location_id: 6,
            start_date: firstDate,
            end_date: secondDate,
          },
          responseType: 'ArrayBuffer'
        }).then(function(response){
          const b64Data = response.body
          const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

          // function to decode a Base64-encoded string into a new string with a character for each byte of the binary data.
          const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
            const byteCharacters = atob(b64Data);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
              const slice = byteCharacters.slice(offset, offset + sliceSize);

              const byteNumbers = new Array(slice.length);
              for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
              }

              const byteArray = new Uint8Array(byteNumbers);
              byteArrays.push(byteArray);
            }

            const blob = new Blob(byteArrays, {type: contentType});
            return blob;
          }

          const blob = b64toBlob(b64Data, contentType);
          const url = URL.createObjectURL(blob);

          const link = document.createElement('a')
          link.href = url
          var file_name = ''
          if(firstDate != null && secondDate != null){
            file_name = "Reporte  desde "+ firstDate +" hasta "+ secondDate +".xlsx"
          }else{
            file_name = "Reporte - "+this.day_today+".xlsx"
          }
          link.setAttribute('download', file_name)
          document.body.appendChild(link)
          link.click()

          if(response.body.meta != undefined &&
              response.body.meta != null){
            if(response.body.meta.authentication_token != undefined &&
                response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined &&
                response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
    },
    dateFormatText(datex, time_zone){
      if (datex !== undefined){
        const moment = require('moment-timezone');
        if(time_zone !== '' && time_zone !== null){
          var date = moment(datex).tz(time_zone).format("MM/DD/YYYY - h:mm a")
        }else{
          var date = moment(datex).format("MM/DD/YYYY - h:mm a")
        }
        var sections=date.split("/");
        var index=Number(sections[0])-1;
        sections[0]=this.months_text[index];
        datex=sections.join(" ");
        return datex;
      } else{
        return undefined
      }
    },
  },
  mounted(){
    this.only_gyms = [{id:'',attributes:{name:'Todos los gimnasios'}}];

    this.only_gyms = this.only_gyms.concat(
                        this.getLocations().filter(function(ele){
                          return ele.attributes.location_type == "Centro Deportivo"
                        }));
    this.getChartsInfo(true);
    this.getBookingsStatistics(false, true)
    // cl current_user
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/views/access/reports.vue